import { clsx } from "clsx";
import { type FC, memo, useRef } from "react";
import { useHover } from "react-aria";
import { shallowEqual, useDispatch } from "react-redux";

import styleTrack from "../styles/Track.module.scss";

import { type TrackCoordinateOrderedCoordinateList } from "../../../graphql.js";
import { getTableSpecFromTrackUsingGenomeInformation } from "../../../redux/modules/genome-browser.js";
import { type ReduxDispatch } from "../../../redux/redux-utils.js";
import { type IFeatureTrackProps } from "../features-track/FeatureTrack.js";
import { useDrawFeatures } from "../hooks/useDrawFeatures.js";
import { CoordinateTrackHeader } from "./CoordinateTrackHeader.js";

interface ICoordinateTrackProps extends IFeatureTrackProps {
  coordinateListData: TrackCoordinateOrderedCoordinateList;
}

const CoordinateTrack: FC<ICoordinateTrackProps> = (props) => {
  const dispatch = useDispatch<ReduxDispatch>();
  const ref = useRef<HTMLDivElement>(null);

  const { hoverProps, isHovered } = useHover({});

  const tableQuerySpec = dispatch(
    getTableSpecFromTrackUsingGenomeInformation(props.track, null, props.coordinateListData.coordinateListId),
  );
  useDrawFeatures({ ...props, tableQuerySpec }, ref);

  const pileup = props.pileup;

  return (
    <div className={clsx(styleTrack.track, { [styleTrack.track_hovered]: isHovered })} {...hoverProps}>
      <CoordinateTrackHeader
        track={props.track}
        coordinateListId={props.coordinateListData.coordinateListId}
        overflow={props.overflow}
        pileup={pileup}
        showAllFeatures={props.showAllFeatures}
        isTrackHovered={isHovered}
      />
      <div className={clsx(styleTrack.container, styleTrack.container_no_top, styleTrack.container_no_bottom)}>
        <div ref={ref} />
      </div>
    </div>
  );
};

const MemoCoordinateTrack = memo(CoordinateTrack, shallowEqual);
export { MemoCoordinateTrack as CoordinateTrack };
